import {
    VIOLATIONS_APPEARS,
} from 'actions';

const defaultState = {
    violations: [],
};

export default (state = defaultState, action) => {
    const {violations, type} = action;
    switch (type) {
        case VIOLATIONS_APPEARS:
            return {
                ...state,
                violations,
            };

        default:
            return state;
    }
};
